import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button } from '@tempmee/react';
import { OutlineWarning01Icon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import ConfirmPopup from '../../../../../shared/ConfirmPopup';
import { CalendarSelection } from '../../../../../../commonComponents';
import { convertDatesToTimezone } from '~/utils/DateUtils';
import { checkIfAnyHoliday } from '~/utils/JobUtils';

export const DateContent = ({
  defaultValues,
  excluded = [],
  onConfirm,
  maxDaysToSelect,
  onLimitExceeded,
}) => {
  const user = useSelector((state) => state.user.selectedChildOffice ?? state.user.user);
  const [selectedDates, setSelectedDates] = useState([]);
  const isDisabled = !selectedDates.length;
  const [confirmPostOnHoliday, setConfirmPostOnHoliday] = useState(false);

  const handleConfirmDates = () => {
    onConfirm(selectedDates);
    setConfirmPostOnHoliday(false);
  };

  const handleButtonClick = () => {
    if (checkIfAnyHoliday(convertDatesToTimezone(selectedDates, user.time_zone))) {
      setConfirmPostOnHoliday(true);
    } else {
      handleConfirmDates();
    }
  };

  useEffect(() => {
    setSelectedDates(defaultValues);
  }, [defaultValues]);

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CalendarSelection
          data-cy="date-input"
          onSelect={setSelectedDates}
          maxDaysToSelect={maxDaysToSelect}
          dates={selectedDates}
          excluded={excluded}
          onLimitExceeded={onLimitExceeded}
        />

        <Button
          data-cy="select-dates-button"
          variant="contained"
          size="md"
          onClick={handleButtonClick}
          disabled={isDisabled}
          style={{ marginTop: 20, marginBottom: 12 }}
        >
          {`Select Date${!maxDaysToSelect || maxDaysToSelect > 1 ? 's' : ''}`}
        </Button>
      </div>

      {confirmPostOnHoliday && (
        <ConfirmPopup
          Icon={() => (
            <div style={{ marginBottom: 20 }}>
              <OutlineWarning01Icon width={80} height={80} color={colors.warning[500]} />
            </div>
          )}
          title="Major U.S Holiday Conflict"
          description={
            <>
              Looks like you are trying to post a shift on a<br />
              Major U.S. Holiday. Please make sure your office
              <br />
              will be open on this date!
            </>
          }
          rightButtonText="Continue"
          leftButtonText="Go Back"
          rightButtonAction={handleConfirmDates}
          leftButtonAction={() => setConfirmPostOnHoliday(false)}
        />
      )}
    </>
  );
};
